/* eslint-disable camelcase */
import _ from 'lodash';
import { SettingSystemUserHeader } from '../system-users/systemUserStyled';
import Heading from '../../../components/typography';
import { COLORS } from '../../../constants/style/color';
import {
  RsuElectionConfig,
  SopElectionConfig,
  SarElectionConfig,
} from '../configuration/components/election-window-config';
import CheckPermissionWithFieldName from '../../../utils/permission/checkPermissionWithFieldName';
import TradePreClearanceTransactionPeriodConfigs from '../trade-pre-clearance/period-config';
import SettlementConfig from './settlementConfig';
import { usePostSettlementConfig, useWealthlaneAwardSettlementApi } from '../../../hooks';
import { useState } from 'react';
import PsuElectionConfig from '../configuration/components/election-window-config/psuElectionConfig';
import EarlyExerciseConfig from './earlyExerciseConfig';
import usePostEarlyExerciseConfig from '../../../hooks/post/usePostEarlyExerciseConfig';

const SettlementConfigContainer = (): JSX.Element => {
  const { handleRequest } = useWealthlaneAwardSettlementApi();
  const { mutate, isLoading: postLoading } = usePostSettlementConfig(handleRequest);
  const { mutate: earlyExerciseMutate, isLoading: postEarlyExerciseLoading } =
    usePostEarlyExerciseConfig(handleRequest);

  return (
    <div data-page="settlementConfig" id="pageContainer">
      <SettingSystemUserHeader id="pageHeader">
        <Heading variant='h3' title='Settlement Configuration' id="pageTitle" />
        <Heading
          variant='body-s'
          title='Set up default and customized tax settlement configurations for award release and exercises.'
          color={COLORS.Gray}
          id="pageDescription"
        />
      </SettingSystemUserHeader>
      <div id="configSections">
        {/* <CheckPermissionWithFieldName fieldName='SettlementConfigs'>
          <SettlementConfig
            handleRequest={handleRequest}
            mutate={mutate}
            postLoading={postLoading}
          />
        </CheckPermissionWithFieldName> */}

        <div id="electionWindowSection">
          <CheckPermissionWithFieldName fieldName='ElectionWindowConfigurations'>
            <div id="electionConfigs">
              <RsuElectionConfig refresher={postLoading} />
              <PsuElectionConfig refresher={postLoading} />
              <SopElectionConfig refresher={postLoading} />
              <SarElectionConfig refresher={postLoading} />
            </div>
          </CheckPermissionWithFieldName>
        </div>
        <div id="settlementConfigSection">
          <CheckPermissionWithFieldName fieldName='SettlementConfigs'>
            <EarlyExerciseConfig
              handleRequest={handleRequest}
              mutate={earlyExerciseMutate}
              postLoading={postEarlyExerciseLoading}
            />
          </CheckPermissionWithFieldName>
        </div>
        <div id="tradePreClearanceSection">
          <CheckPermissionWithFieldName fieldName='TradePreClearanceTransactionPeriodConfigs'>
            <TradePreClearanceTransactionPeriodConfigs />
          </CheckPermissionWithFieldName>
        </div>
      </div>
    </div>
  );
};

export default SettlementConfigContainer;
